import { values } from 'lodash'

import { createOptionsFromEnum } from '../utils/createOptionsFromEnum'

export const FACM_STATUS = {
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  ONGOING: 'ONGOING',
  REJECTED: 'REJECTED',
  WAITING_CORPS_CHIEF: 'WAITING_CORPS_CHIEF',
  WAITING_MOUNTAIN_OFFICER: 'WAITING_MOUNTAIN_OFFICER',
  WAITING_UNIT_COMMANDER: 'WAITING_UNIT_COMMANDER',
  ALERT: 'ALERT',
}

export const FACM_FILTER_STATUS = {
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  ONGOING: 'ONGOING',
  REJECTED: 'REJECTED',
  WAITING: 'WAITING',
  ALERT: 'ALERT',
}

export const FACM_STATUS_ARRAY = values(FACM_STATUS)

export const DRAFTLESS_STATUSES = FACM_STATUS_ARRAY.filter((s) => s !== FACM_STATUS.DRAFT)

export const DRAFTLESS_FILTER_STATUSES = values(FACM_FILTER_STATUS).filter((s) => s !== FACM_STATUS.DRAFT)

export const DRAFTLESS_STATUSES_OPTIONS = createOptionsFromEnum({
  values: DRAFTLESS_FILTER_STATUSES, prefix: 'facmStatus',
})
